var _polygon, _path, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScriptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Messaging",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Write") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "144 304 144 368 208 368 144 304"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.34,42.32,469.68,5.66a19.34,19.34,0,0,0-27.35,0L424,24l64,64,18.34-18.34A19.34,19.34,0,0,0,506.34,42.32Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "160 288 224 352 472 103.81 408 40 160 288"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "400 464 48 464 48 112 268.12 112 316.12 64 0 64 0 512 448 512 448 195.73 400 243.77 400 464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptIcon);
export default __webpack_public_path__ + "static/media/scriptIcon.a98b53dd8f5b2ae5225a954e825302b9.svg";
export { ForwardRef as ReactComponent };